import React from "react";

const Button = ({
    children, // Button text
    onClick, // Click handler
    type = "button", // Button type: 'button', 'submit', etc.
    variant = "primary", // Style variant: 'primary', 'secondary', 'danger', etc.
    size = "md", // Size: 'sm', 'md', 'lg'
    disabled = false, // Disabled state
    className = "", // Additional custom classes
    icon = null, // Icon component
}) => {
    const baseStyles = "rounded focus:outline-none focus:ring-2 font-medium transition-all";
    const sizeStyles = {
        sm: "px-2 py-1 text-sm",
        md: "px-4 py-2 text-base",
        lg: "px-6 py-3 text-lg",
    };
    const variantStyles = {
        primary: "bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-300",
        secondary: "bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-300",
        danger: "bg-red-500 text-white hover:bg-red-600 focus:ring-red-300",
        success: "bg-green-500 text-white hover:bg-green-600 focus:ring-green-300",
        secondaryoutline: "px-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${className}`}
        >
            {icon && <span className="mr-2">{icon}</span>}
            {children}
        </button>
    );
};

export default Button;
